<template>
    <form ref="recurring_pause" class="pop-up--form card card--lg" v-on:submit.prevent="submit">
        <div class="card__header">
            <p class="card__title">Pause my order</p>
            <p class="card__subtitle">Going on holiday? Visiting a relative for the weekend? Plan a pause in your order. The resume date is the date when you want to start to be delivered again.</p>
        </div>
        <div class="card__content">
            <div class="form">
                <div class="form__field form__field--md6">
                    <label for="startDate" class="form__label">Stop date</label>
                    <input name="pause_start" class="form__control form-field required datepicker-start" autocomplete="off" type="text" v-model="dateStart" id="startDate">
                    <div class="form__icon">
                        <icon-calendar></icon-calendar>
                    </div>
                </div>
                <div class="form__field form__field--md6">
                    <label for="endDate" class="form__label">Resume date</label>
                    <input name="pause_end" class="form__control form-field required datepicker-end" autocomplete="off" type="text" v-model="dateEnd" id="endDate">
                    <div class="form__icon">
                        <icon-calendar></icon-calendar>
                    </div>
                </div>
                <div class="form__field">
                    <p class="caption text--regular">Because we want to make life easy for you, let us know about your return so we can keep your chosen time slots unchanged.</p>
                </div>
                <div class="form__field">
                    <div class="form__control checkbox">
                        <div class="checkbox__item checkbox__item--required">
                            <input type="checkbox" name="terms" class="checkbox__control required" id="terms" value="">
                            <label for="terms" class="checkbox__label">I confirm that I want to pause my order</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="this.loading">
            <popup-loader></popup-loader>
        </div>
        <div class="card__actions">
            <button type="submit" class="button button--md button--secondary">Pause</button>
        </div>
    </form>
</template>

<script>
export default {
    data() {
        return {
            dateStart: null,
            dateEnd: null,
            minStart: null,
            minEnd: null,
            loading: false,
        }
    },

    beforeMount() {
        if (this.$root.orders.recurring) {
            if (this.$root.orders.recurring.pause_from) {
                this.dateStart = moment(this.$root.orders.recurring.pause_from).format("DD/MM/YYYY");
            }

            if (this.$root.orders.recurring.pause_to) {
                this.dateEnd = moment(this.$root.orders.recurring.pause_to).format("DD/MM/YYYY");
            }
        }
    },

    mounted() {
        let closingTime = new Date();
        closingTime.setHours(window.config.closing_time);

        let now = new Date();
        // now.setHours(now.getUTCHours()); // GMT
        now.setHours(now.getUTCHours() + 1); // BST

        this.minStart = new Date();
        this.minStart.setDate(this.minStart.getDate() + 2);

        // Allow order for tomorrow until specific hours, or +2 days
        if (now.getHours() >= closingTime.getHours()) {
            this.minStart.setDate(this.minStart.getDate() + 2);
        }

        this.minEnd = new Date(this.minStart);
        this.minEnd.setDate(this.minEnd.getDate() + 2);

        $('.datepicker-start').datepicker({
            format: 'dd/mm/yyyy',
            weekStart: 1,
            startDate: this.minStart
        }).on('changeDate', (e) => {
            this.dateStart = e.target.value;

            // Reset end date because must be after this date
            let dateMomentObject = moment(this.dateStart, "DD/MM/YYYY");
            this.minEnd = new Date(dateMomentObject.toDate());
            this.minEnd.setDate(this.minEnd.getDate() + 1);
            this.dateEnd = null;
            $('.datepicker-end').datepicker('setStartDate', this.minEnd);
        });

        $('.datepicker-end').datepicker({
            format: 'dd/mm/yyyy',
            weekStart: 1,
            startDate: this.minEnd
        }).on('changeDate', (e) => {
            this.dateEnd = e.target.value;
        });
    },

    methods: {
        submit() {
            if (!$(this.$refs.recurring_pause).valid()) return false;
            this.loading = true;

            // Order
            axios.post(`/api/order/recurring/${this.$root.orders.recurring.id}/status`, {
                customer_id: this.$root.user.id,
                token: this.$root.user.password,
                date_start: this.dateStart,
                date_end: this.dateEnd,
                status: 'PAUSED'
            }).then(res => {
                if (res.success === false) {

                } else {
                    // Show alert
                    this.$root.recurringPause = null;
                    this.$root.alert = {
                        type: "SUCCESS",
                        title: "Pause order",
                        text: "Your recurring order has been paused."
                    };

                    // Update datas
                    this.$root.orders.recurring = res.data.datas.recurring;
                    this.$root.orders.upcoming = res.data.datas.upcoming;
                    this.$root.next_delivery = res.data.datas.next_delivery;
                    this.$root.next_recurring_orders = res.data.datas.next_recurring_orders;
                }
                this.loading = false;
            }).catch(error => console.log(error));
        }
    }
}
</script>
